import { gql } from '@apollo/client'

export const INJURY_MASTER_SETTINGS_QUERY = gql`
  query INJURY_MASTER_SETTINGS_QUERY {
    injuryMasterSettings {
      accountId
      environment
      companyId
      schemeId
      updatedAt
    }
  }
`

export const INJURY_MASTER_IS_CONFIGURED_QUERY = gql`
  query INJURY_MASTER_IS_CONFIGURED_QUERY {
    injuryMasterIsConfigured
  }
`

export const INJURY_MASTER_COMPANIES_QUERY = gql`
  query INJURY_MASTER_COMPANIES_QUERY {
    injuryMasterCompanies {
      id
      name
      number
    }
  }
`

export const INJURY_MASTER_SCHEMES_QUERY = gql`
  query INJURY_MASTER_SCHEMES_QUERY {
    injuryMasterSchemes {
      id
      name
    }
  }
`

export const INJURY_MASTER_INCIDENT_PROPERTIES_QUERY = gql`
  query INJURY_MASTER_INCIDENT_PROPERTIES_QUERY {
    injuryMasterIncidentProperties {
      property
      label
      kind
      hint
      requiredOnCreate
      compatibleFieldTypes
      lookupSource
      listType
      supportsFixedValue
      choices {
        value
        label
      }
    }
  }
`

export const INJURY_MASTER_RECORDS_QUERY = gql`
  query INJURY_MASTER_RECORDS_QUERY($listType: InjuryMasterListType!, $search: String, $page: Int) {
    injuryMasterRecords(listType: $listType, search: $search, page: $page) {
      records {
        url
        name
      }
      hasMore
    }
  }
`

export const INJURY_MASTER_RECORDS_BY_URL_QUERY = gql`
  query INJURY_MASTER_RECORDS_BY_URL_QUERY($urls: [String!]!) {
    injuryMasterRecordsByUrl(urls: $urls) {
      url
      name
    }
  }
`

// The latest "Sync now" run. Poll it while its status is QUEUED or RUNNING.
export const INJURY_MASTER_SYNC_RUN_QUERY = gql`
  query INJURY_MASTER_SYNC_RUN_QUERY {
    injuryMasterSyncRun {
      id
      status
      entityType
      startedAt
      finishedAt
      progress {
        entityType
        total
        synced
        skipped
        failed
      }
    }
  }
`
